import {ApiProcessedBookingPermissions} from "../constants/ApiPermissions";
import RulesetBase from "./rulesetBase";

class TransactionRuleset extends RulesetBase {
  defineRules = (userPermissions: string[]): void => {
    const {can} = this.abilityBuilder;
    for (let permission of userPermissions) {
      if (
        permission.toUpperCase() ===
        ApiProcessedBookingPermissions.read.toUpperCase()
      ) {
        can("Read", "ProcessedBooking");
        break;
      }
    }
  };
}

export default TransactionRuleset;
